import cookie from 'js-cookie';

import { getCookieDomain } from './get-cookie-domain';

export function removeCookie(cookieName: string) {
  cookie.remove(cookieName, { path: '/', domain: getCookieDomain() });
}
